<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="4">
          <!-- export excel -->
          <v-btn color="secondary" @click="downloadProfitSummaryRpt"><v-icon small>download</v-icon> Export Excel</v-btn>
          <!-- Reload button -->
          <v-btn color="secondary" @click.stop="reload()">
            <i class="fa fa-repeat fa-xs"></i>&nbsp;Reload
          </v-btn>
        </v-col>
        <!-- <v-btn @click="resetFilter" class="ml-2"  style="float: right">Reset Filters</v-btn> -->
        <v-col cols="8">
          <div class="d-flex" style="justify-content:right">
            <v-menu
              ref="startDatePicker"
              v-model="startDateCal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              dense
              max-width="350px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  style="min-width:250px;max-width:250px;"
                  label="Start Date"
                  placeholder="Start Date"
                  v-model="startDate"
                  dense
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <!-- <v-btn
                  text
                  color="secondary"
                  @click="cancelStartMonth()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="secondary"
                  @click="searchStartMonthOk()"
                >
                  OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
            <span class="date-divider"> - </span>
            <v-menu
              ref="endDatePicker"
              v-model="endDateCal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              dense
              max-width="350px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="mr-3"
                  style="min-width:250px;max-width:250px;"
                  label="End Date"
                  placeholder="End Date"
                  v-model="endDate"
                  dense
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <!-- <v-btn
                    text
                    color="secondary"
                    @click="cancelEndMonth()"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="secondary"
                    @click="searchEndMonthOk()"
                >
                    OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
            <v-text-field style="max-width:350px;" class="pt-0" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-btn @click="getProfitSumary" color="secondary" class="ml-2">Apply</v-btn>
          </div>
        </v-col>
      </v-col>
    </v-row>
    <div class="d-flex flex-row mt-3" style="justify-content:space-between;margin:0;padding:0;">
      <v-flex md4 sm4 xs12 pa-3>
        <v-card dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Profit Summary for {{currentMonthLabel}}</v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 h3">${{currentMthProfit |thousandSeprator}}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md8 sm8 xs12 pa-3>
        <v-card dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Profit Summary {{showFilterDate}}</v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 h3">${{totalValues.profit |thousandSeprator}}</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <div>
      <v-row>
        <v-col class="d-flex" cols="12" style="justify-content:right">
          <div class="mr-2" :key="index" v-for="(quater, index) in filterQuaters">
            <v-btn                      
              :color="quater.selected ? 'warning' : 'default'"
              small
              v-bind="attrs"
              v-on="on"
              @click="changeQuater(quater.value)"
            >
              {{quater.label}}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="mt-5">
      <v-data-table
        ref="ProfitSummaryTable"
        :headers="headers"
        :search="filter"
        :items="filteredItems"
        :items-per-page="15"
        class="profit-summary-table elevation-1"
        @current-items="getFiltered">
          <template v-for="(h, index) in headers" v-slot:[`header.${h.value}`]="{ header }">
            <legend-icon :key="index" :header="h" iconColor="#fb8c00" />
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            <td class="text-start">
              <span v-if="item.createdAt">{{formatDateTime(item.createdAt)}}</span>
            </td>
          </template>
          <template v-slot:[`item.IONumber`]="{ item }">
            <td class="text-start">
              <span v-if="item.IONumber">{{item.IONumber}}</span>
            </td>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            <td class="text-start">
              <span v-if="item.budget">${{item.budget | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <td class="text-start">
              <span v-if="item.amount">${{item.amount | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.cogsTotal`]="{ item }">
            <td class="text-start">
              <span v-if="item.cogsTotal">${{item.cogsTotal | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.targetCOGS`]="{ item }">
            <td class="text-start">
              <span v-if="item.targetCOGS">${{item.targetCOGS | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.actualCOGS`]="{ item }">
            <td class="text-start">
              <span v-if="item.actualCOGS">${{item.actualCOGS | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.savingCOGS`]="{ item }">
            <td class="text-start">
              <span v-if="item.savingCOGS">${{item.savingCOGS | thousandSeprator}} {{item.savingPercent ? `(${item.savingPercent}%)`: ''}}</span>
            </td>
          </template>
          <template v-slot:[`item.grossProfit`]="{ item }">
            <td class="text-start">
              <span v-if="item.grossProfit">${{item.grossProfit | thousandSeprator}}</span>
            </td>
          </template>
      </v-data-table>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>
<script>
// import config from '@/config';
import paymentAPIs from '../paymentAPIs';
import LegendIcon from '@/components/reports/LegendIcon';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState, mapGetters } from 'vuex'
import utils from '@/utils';
import sumBy from 'lodash/sumBy';
import orderBy from 'lodash/orderBy';
const moment = require('moment')
export default {
  name: 'ProfitSummaryDataTable',
  components: {
    LegendIcon,
    Loading
  },
  data() {
    return {
      headers: [
        {
          text: 'Campaign Creation Date',
          value: 'createdAt',
          align: 'start'
        },
        {
          text: 'IO Number',
          value: 'IONumber',
          align: 'start'
        },
        {
          text: 'Client Name',
          value: 'clientName',
          align: 'start'
        },
        {
          text: 'Campaign Name',
          value: 'name',
          align: 'start'
        },
        {
          text: 'Budget',
          value: 'budget',
          align: 'start'
        },
        {
          text: 'COGS',
          value: 'cogsTotal',
          align: 'start'
        },
        {
          text: 'Target COGS',
          value: 'targetCOGS',
          align: 'start'
        },
        {
          text: 'COGS Savings',
          value: 'savingCOGS',
          align: 'start'
        },
        {
          text: 'Gross Profit',
          legendText: 'Budget - COGS',
          value: 'grossProfit',
          align: 'start'
        }
      ],
      items: [],
      filterQuaters: [
        {
          label: 'Q1',
          value: 'Q1'
        },
        {
          label: 'Q2',
          value: 'Q2'
        },
        {
          label: 'Q3',
          value: 'Q3'
        },
        {
          label: 'Q4',
          value: 'Q4'
        }
      ],
      filter: '',
      filteredItems: [],
      selectedFilter: {
        startDate: '',
        endDate: '',
        quarter: '',
        reload: false
      },
      startDate: '',
      endDate: '',
      startDateCal: false,
      endDateCal: false,
      totalValues: {
        profit: 0
      },
      isLoading: false,
      createCogsEstimateDialog: false,
      currentMthProfit: 0,
      dataTableFilteredItems: []
    }
  },
  computed: {
    ...mapState({
      profitSummary: state => state.payment.profitSummary
    }),
    ...mapGetters('payment', [
      'formatDate'
    ]),
    currentMonthLabel() {
      return moment().format('MMM YYYY')
    },
    showFilterDate: function () {
      if (this.selectedFilter.startDate || this.selectedFilter.endDate) {
        let respDateStr = 'for '
        if (this.selectedFilter.startDate) {
          respDateStr += utils.func.formatCustomDate(this.selectedFilter.startDate, 'MMM YYYY')
        }
        if (this.selectedFilter.startDate && this.selectedFilter.endDate) {
          respDateStr += ' - '
        }
        if (this.selectedFilter.endDate) {
          respDateStr += utils.func.formatCustomDate(this.selectedFilter.endDate, 'MMM YYYY')
        }
        return respDateStr
      }
      return ''
    }
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      // set current year if not date filters
      this.startDate = moment().format('YYYY') + '-01'
      this.endDate = moment().format('YYYY') + '-12'
      await this.getCurrentMonthProfit()
      this.getProfitSumary()
    },
    async getCurrentMonthProfit() {
      this.isLoading = true
      await this.$store.dispatch('payment/getProfitSummary', {
        filters: {
          startDate: moment().format('YYYY-MM'),
          endDate: moment().format('YYYY-MM')
        }
      })
      let items = this.beautifyData()
      this.currentMthProfit = Number(sumBy(items, (item) => { return Number(item.grossProfit) }))
      this.currentMthProfit = this.currentMthProfit.toFixed(2)
      this.isLoading = false
    },
    async getProfitSumary() {
      this.isLoading = true
      this.selectedFilter.startDate = this.startDate
      this.selectedFilter.endDate = this.endDate
      await this.$store.dispatch('payment/getProfitSummary', {
        filters: this.selectedFilter
      })
      this.searchFilter()
      this.calcTotalSummary(this.filteredItems)
      this.isLoading = false
      this.selectedFilter.reload = false
    },
    beautifyData() {
      let items = []
      this.profitSummary.map(p => {
        if (p.campaigns && Array.isArray(p.campaigns)) {
          items.push(...p.campaigns)
        }
      })
      items = items.map(item => {
        item.cogsTotal = Number(item.cogsTotal).toFixed(2)
        item.grossProfit = Number(item.grossProfit).toFixed(2)
        return item
      })
      return items
    },
    // resetFilter() {
    //   // reset filters
    //   this.selectedFilter = {
    //     startDate: '',
    //     endDate: '',
    //     quarter: '',
    //     reload: false
    //   }
    //   this.filter = ''
    //   this.getProfitSumary()
    // },
    searchFilter() {
      this.items = this.beautifyData()
      this.filteredItems = this.items.map(i => i)
      this.filteredItems = orderBy(this.filteredItems, ['createdAt'], ['desc'])
      // set quaterly filter for preview only
      if (this.selectedFilter.quarter) {
        let currentYear = moment().format('YYYY')
        if (this.selectedFilter.quarter === 'Q1') {
          this.startDate = `${currentYear}-01`
          this.endDate = `${currentYear}-03`
        } else if (this.selectedFilter.quarter === 'Q2') {
          this.startDate = `${currentYear}-04`
          this.endDate = `${currentYear}-06`
        } else if (this.selectedFilter.quarter === 'Q3') {
          this.startDate = `${currentYear}-07`
          this.endDate = `${currentYear}-09`
        } else if (this.selectedFilter.quarter === 'Q4') {
          this.startDate = `${currentYear}-10`
          this.endDate = `${currentYear}-12`
        }
        this.selectedFilter.startDate = this.startDate
        this.selectedFilter.endDate = this.endDate
      }
    },
    changeQuater(item) {
      this.filterQuaters = this.filterQuaters.map(ct => {
        if (ct.value === item) {
          if (!ct.selected) {
            ct.selected = true
            this.selectedFilter.quarter = ct.value
          } else {
            this.selectedFilter.quarter = ''
            ct.selected = false
            this.init()
          }
        } else {
          ct.selected = false
        }
        return ct
      })
      this.getProfitSumary()
    },
    // searchStartMonthOk() {
    //   this.startDateCal = false
    //   this.getProfitSumary()
    // },
    // async cancelStartMonth() {
    //   this.startDateCal = false
    //   this.selectedFilter.startDate = ''
    //   this.getProfitSumary()
    // },
    // searchEndMonthOk() {
    //   this.endDateCal = false
    //   this.getProfitSumary()
    // },
    // async cancelEndMonth() {
    //   this.endDateCal = false
    //   this.selectedFilter.endDate = ''
    //   this.getProfitSumary()
    // },
    resetTotalValues() {
      this.totalValues = {
        profit: 0
      }
    },
    calcTotalSummary(items = []) {
      this.resetTotalValues()
      if (!items.length) {
        return;
      }
      this.totalValues.profit = Number(sumBy(items, (item) => { return Number(item.grossProfit) }))
      this.totalValues.profit = this.totalValues.profit.toFixed(2)
    },
    getFiltered() {
      this.$nextTick(() => {
        this.calcTotalSummary(this.$refs.ProfitSummaryTable.$children[0].filteredItems)
        this.dataTableFilteredItems = this.$refs.ProfitSummaryTable.$children[0].filteredItems
      });
    },
    formatDateTime(createdAt) {
      return moment(createdAt).format('DD/MM/YYYY')
    },
    downloadProfitSummaryRpt() {
      this.isLoading = true
      paymentAPIs
        .downloadProfitSummaryRpt(this.dataTableFilteredItems)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading profit summary report', error);
        });
    },
    reload() {
      this.selectedFilter.reload = true
      this.selectedFilter.quarter = ''
      this.filterQuaters = this.filterQuaters.map(f => {
        f.selected = false
        return f
      })
      this.init()
    }
  }
}
</script>
<style scoped>
  .date-divider {
    width: 30px;
    text-align: center;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?068235c3